import React from "react";

import styles from "./ClearAllFields.module.scss";

/**
 *
 * @param {String} className - additional className to add
 * @param {Function} onClick - event handler to clear fields (pass function to change parent state)
 */
const ClearAllFields = props => {
    return (
        <div
            className={`${styles["clear-all-fields"]} ${props.className || ""}`}
            onClick={props.onClick || null}
        >
            <i className={`fal fa-times-circle ${styles["times-icon"]}`} />
            <u className={styles["clear-all-fields-text"]}>Clear All Fields</u>
        </div>
    );
};

export default ClearAllFields;
